import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { tldPromotionsApiClient } from './TldPromotionsWithPrice.apiClient';
import { Box, Heading, Text } from '@wix/design-system';
import s from '../common.scss';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useIsMobile } from '@wix/core-domain-search';
import { useDeclaredExperiments } from '../../hooks/declaredExperiments';
import { usePerceptionEnabled } from '../../pricingPerception';
import { PerceptionTldBadge, PerceptionTldPriceSlot } from './PerceptionTldSlots';
export const getFallback = t => [{
  id: 'com-fallback',
  tld: 'com',
  description: t('domain_search_gate.tld_section.tld_fallback.com')
}, {
  id: 'net-fallback',
  tld: 'net',
  description: t('domain_search_gate.tld_section.tld_fallback.net')
}, {
  id: 'org-fallback',
  tld: 'org',
  description: t('domain_search_gate.tld_section.tld_fallback.org')
}, {
  id: 'store-fallback',
  tld: 'store',
  description: t('domain_search_gate.tld_section.tld_fallback.store')
}, {
  id: 'app-fallback',
  tld: 'app',
  description: t('domain_search_gate.tld_section.tld_fallback.app')
}, {
  id: 'co-fallback',
  tld: 'co',
  description: t('domain_search_gate.tld_section.tld_fallback.co')
}, {
  id: 'ai-fallback',
  tld: 'ai',
  description: t('domain_search_gate.tld_section.tld_fallback.ai')
}, {
  id: 'info-fallback',
  tld: 'info',
  description: t('domain_search_gate.tld_section.tld_fallback.info')
}];
const Base44ExtensionsBadge = () => {
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(React.Fragment, null, t('domains_search_gate.base44.gate.extensions.badge'));
};
export const TldPromotionsWithPrice = _ref => {
  var _data$tldPromotionsWi;
  let {
    variant = 'grid'
  } = _ref;
  const isMobile = useIsMobile();
  const isBase44 = variant === 'base44';
  const compact = isBase44 && isMobile;
  const titleKey = isBase44 ? 'domains_search_gate.base44.gate.extensions.title' : 'domain_search_gate.domain_gate.tld_section.header';
  const layout = isBase44 ? isMobile ? 'list' : 'grid' : variant;
  const experimentIds = useDeclaredExperiments();
  // Base44 keeps its own badge, so the arm only takes over the standard gate grid.
  const reframed = usePerceptionEnabled() && !isBase44;
  const {
    data,
    isLoading,
    error
  } = tldPromotionsApiClient.hooks.useTldPromotionsWithPrice({
    limit: 8,
    experimentIds
  }, true, {
    useErrorBoundary: false
  });
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const promotions = error || !(data != null && (_data$tldPromotionsWi = data.tldPromotionsWithPrice) != null && _data$tldPromotionsWi.length) ? getFallback(t) : data == null ? void 0 : data.tldPromotionsWithPrice;
  const TldPromotionComponent = layout === 'list' ? DomainSearchSuiteModule.SDK.Components.TldPromotionsList : DomainSearchSuiteModule.SDK.Components.TldPromotions;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isMobile ? '0px' : 'SP4',
    width: "100%",
    align: "center",
    padding: compact ? '0' : 'SP10 0 SP10 0'
  }, /*#__PURE__*/React.createElement(Box, {
    padding: compact ? '0 0 SP4 0' : isMobile ? 'SP4 0 4px 0' : 'SP4 0 SP3 0'
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t(titleKey))), /*#__PURE__*/React.createElement(TldPromotionComponent, {
    isLoading: isLoading,
    promotions: promotions,
    compact: compact,
    Label: isBase44 ? Base44ExtensionsBadge : undefined,
    PromotionBadge: reframed ? PerceptionTldBadge : undefined,
    PromotionPrice: reframed ? PerceptionTldPriceSlot : undefined
  }), /*#__PURE__*/React.createElement(Box, {
    paddingTop: compact ? 'SP2' : undefined
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    light: true
  }, t('domain_search_gate.domain_gate.pricing_disclaimer'))));
};
//# sourceMappingURL=TldPromotionsWithPrice.js.map